import {
  BitkitExpandableCard,
  IconCheckCircle,
  IconCrossCircleFilled,
  IconErrorCircleFilled,
  IconSkipCircle,
} from '@bitrise/bitkit-v2';
import { Box } from '@chakra-ui/react/box';

import { TestCaseRun } from '../../TestResults.types';
import TestCaseDetailsTabs from '../tabs/TestCaseDetailsTabs';
import Duration from './Duration';

const ICON_PROPS_MAP = {
  passed: { color: 'status/success/icon', icon: IconCheckCircle },
  failed: { color: 'status/critical/icon', icon: IconCrossCircleFilled },
  skipped: { color: 'status/warning/icon', icon: IconSkipCircle },
  error: { color: 'status/critical/icon', icon: IconErrorCircleFilled },
} as const;

const TestCaseRuns = ({ runs }: { runs: TestCaseRun[] }) => {
  return (
    <Box padding="16" display="flex" flexDirection="column" gap="8">
      {runs.map((run) => {
        const { icon, color } = ICON_PROPS_MAP[run.status];

        return (
          <BitkitExpandableCard
            key={run.name}
            elevation={false}
            icon={icon}
            iconColor={color}
            noPadding
            suffix={<Duration durationInMs={run.durationInMs ?? 0} />}
            title={run.name}
          >
            <TestCaseDetailsTabs key={run.name} testOutput={run.message} attachments={run.attachments} />
          </BitkitExpandableCard>
        );
      })}
    </Box>
  );
};

export default TestCaseRuns;
